import getValidationCallback from "./signUpValidator";

const configElement = document.querySelector('[data-auth0-parameter]');
const keepMeLoggedSection = document.querySelector('[data-keep-me-logged-section]');
const legalContentSection = document.querySelector('[data-legal-section]');
const configObject = JSON.parse(configElement.innerText);
configObject.keepMeLoggedSection = keepMeLoggedSection;
configObject.legalContentSection = legalContentSection;
configObject.options.additionalSignUpFields.forEach((signUpField) => {
    const callback = getValidationCallback(signUpField);
    signUpField.validator = callback;
});

/**
 * @public
 * getBaseConfig: get the configuration object to show authentication modal.
 *
 * @returns { Object } with the configuration of authentication.
 */
function getBaseConfig() {
    return Object.assign({}, configObject);
}

export default getBaseConfig;
